module.exports = __webpack_public_path__ + "static/media/cargaMasiva.2a12d851.png";